import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-author-cell-renderer',
    styleUrls: ['./author-cell-renderer.component.scss'],
    template: '<div class="author-wrapper">{{ author }}</div>',
    standalone: false,
})
export class AuthorCellRendererComponent implements ICellRendererAngularComp {
    author: string | undefined;

    agInit(params: ICellRendererParams): void {
        this.author = params.value;
    }

    refresh(params: ICellRendererParams): boolean {
        this.author = params.value;
        return true;
    }
}
